import React from "react";
import { Link } from "react-router-dom";

export default function Disclaimer() {
    return (
        <div className="max-w-3xl mx-auto p-4 sm:p-6 text-gray-200">
            <h1 className="text-2xl sm:text-3xl font-bold mb-4">Legal Investment Disclaimer</h1>
            <div className="space-y-4">
                <p>
                    The content, tools, and services provided on this website, including but not
                    limited to AI-generated predictions, trading insights, and financial data, are
                    intended solely for informational purposes and do not constitute investment
                    advice, financial guidance, or a recommendation to buy or sell any securities.
                </p>
                <p>
                    No part of this website shall be interpreted as a solicitation or offer to
                    engage in any investment strategy or transaction. Users acknowledge that
                    investing in the stock market involves substantial risk, including the
                    potential loss of capital.
                </p>
                <p>
                    While reasonable efforts are made to ensure the accuracy of the information
                    presented, we make no warranties or guarantees, express or implied, regarding
                    the completeness, timeliness, or reliability of any content.
                </p>
                <p>
                    You are solely responsible for your investment decisions. We recommend
                    consulting with a licensed financial advisor or registered investment
                    professional before acting on any information provided herein.
                </p>
                <p>
                    By using this website, you agree to hold harmless its creators, affiliates, and
                    contributors from any and all claims, liabilities, losses, or damages resulting
                    from your use of the platform.
                </p>
                <p>All investments carry risk. Past performance does not guarantee future results.</p>
            </div>

            <Link to="/" className="inline-block mt-6 text-blue-400 hover:underline">
                ← Back to Home
            </Link>
        </div>
    );
}

// JavaScript source code
